<template>
  <div class="local-distribution">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
          <el-select 
            class="white"
            clearable
            v-model="searchForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
          ></el-date-picker>
        </el-form-item>
        <el-button class="btn-blue" @click="search">搜索</el-button>
        <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white entry"
          icon="el-icon-download"
          @click="openEntry"
          >录入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    
    <!-- 录入 -->
    <el-dialog
      title="录入"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="entry-dialog"
    >
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <el-form-item label="仓库" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="entryForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="entryForm.date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="当月成本" prop="monthCost">
          <el-input
            class="gray white"
            v-model="entryForm.monthCost"
            placeholder="请输入"
            clearable
            @input="monthCostInput(entryForm.monthCost)"
          ></el-input>
        </el-form-item>
        <el-form-item label="停运日期" prop="outageDate">
          <el-date-picker
            v-model="entryForm.outageDate"
            :picker-options="pickerOptions"
            type="dates"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import LocalDistribution from "models/data-entry/local-distribution";
import { inputAllTwoDecimal, formatTimeToYearAndMonth } from "common/js/util";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '当月成本', prop: 'monthCost', width: ''},
        {label: '停运日期', prop: 'outageDate', width: ''},
        {label: '日均成本', prop: 'averageDailyCost', width: ''}
      ],
      warehouseList: [],
      searchForm: {
        warehouseId: '',
        date: ''
      },
      
      dialog: false,
      entryForm: {
        warehouseId: '',
        date: formatTimeToYearAndMonth(),
        monthCost: '',
        outageDate: '',
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        monthCost: [
          { required: true, message: '请输入当月成本', trigger: 'blur' }
        ],
        outageDate: [
          { required: true, message: '请选择停运日期', trigger: 'change' }
        ]
      },

      //日期选择范围在一个月内
      pickerOptions: {
        // 限制日期
        disabledDate: this.disabledDate,
      },
    }
  },

  watch: {
    'entryForm.outageDate': {
      handler(newVal) {
        if (!this.entryForm.date && newVal) {
          this.entryForm.outageDate = ''
          this.$message({
            type: 'error',
            message: '请先选择日期'
          })
          return 
        }
      }
    }
  },

  created() {
    this.initList()
    this.getWarehouseList()
  },

  methods: {
    disabledDate(time) {
      const oneDay = 24 * 3600 * 1000
      let date = new Date(this.entryForm.date)
      let selectDate = date.getTime() 
      let year = date.getFullYear() 
      let month = date.getMonth() 
      // 获取当月总天数
      let days = new Date(year, month+1, 0).getDate()
      let one = (days-1) * 24 * 3600 * 1000;
      const minTime = selectDate - oneDay;
      const maxTime = selectDate + one;
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return time.getTime() < minTime || time.getTime() > maxTime;;
    },

    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    
    initList() {
      let currentPage = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let date = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        date
      }

      LocalDistribution.getLocalDistributionList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.date
            obj.warehouseName = i.warehouseName
            obj.monthCost = i.monthCost
            let outageDate = ''
            i.cityDeliveryOutageDateList.map(i => {
              outageDate += `；${i.substring(5)}`
            })
            obj.outageDate = outageDate.substring(1)
            obj.averageDailyCost = i.dayCost
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    openEntry() {
      this.dialog = true
    },

    closeDialog() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.entryForm.monthCost = ''
      this.entryForm.outageDate = ''
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let date = this.entryForm.date
          let monthCost = Number(this.entryForm.monthCost)
          let outageDateList = this.entryForm.outageDate
          let data = {
            warehouseId,
            date,
            monthCost,
            outageDateList
          }
          LocalDistribution.postEntryLocalDistribution(data).then(res => {
            if (res.success) {
              this.initList()
              this.closeDialog()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    monthCostInput(v) {
      this.entryForm.monthCost = inputAllTwoDecimal(v);
    }
  }
}
</script>

<style lang='scss'>
.local-distribution {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .btn-blue,
    .btn-gray {
      margin-left: 16px;
    }
    .entry {
      padding: 0px 14px;
    }
    .el-form {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 72px;
      .el-form-item {
        margin-bottom: 0px;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
  }
  .table {
    padding: 16px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  .entry-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .entry-form {
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      padding-top: 20px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
